import React from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import Popup from 'reactjs-popup';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import modules from '../../data/modules';
import Anchor from '../Basic/Anchor';
import Desc from '../Basic/Desc';
import Heading from '../Basic/Heading';
import EVideo from '../Emoji/EVideo';
import Code from './Code';
import Hr from './Hr';
import Img from './Img';
import Module from './Module';
import No from './No';
import P from './P';
import Title from './Title';
import Wrap from './Wrap';

export default () => (
	<>
		<Heading>What You Get in This Course?</Heading>
		<Desc>
			For beginners or advanced developer? Both! Investing time on your code editor can help you improve your
			productivity. After this course, you'll be writing code with best practices, 2x faster than you do now, and
			will be saving 15 to 20 hours every month. Details in the modules below.
		</Desc>
		<Wrap>
			{modules.map((m, i) => (
				<Module key={i}>
					<ScrollableAnchor id={`module${i + 1}`}>
						<span />
					</ScrollableAnchor>

					<Img className="lazyload" data-src={m.img} alt={m.title} loading="lazy" />
					<No>MODULE #{i + 1}</No>
					<Title>
						<Anchor href="#signup">{m.title}</Anchor>
					</Title>
					<Info>
						<P dangerouslySetInnerHTML={{ __html: m.desc }} />
						<Hr />

						{m.lessons.map((lsn, i) => {
							if (lsn.video) {
								return (
									<Popup
										key={i}
										trigger={
											<Lesson key={i}>
												<EVideo width="24" height="24" />{' '}
												<span dangerouslySetInnerHTML={{ __html: lsn.title }} />
												<Play>WATCH NOW!</Play>
											</Lesson>
										}
										modal={true}
										lockScroll={true}
									>
										{(close) => (
											<Modal>
												<Close onClick={close}>&times;</Close>
												<iframe
													title="Sample lesson video"
													src={`https://player.vimeo.com/video/${lsn.video}`}
													width="640"
													height="360"
													frameBorder="0"
													webkitallowfullscreen="true"
													mozallowfullscreen="true"
													allowfullscreen="true"
												/>
											</Modal>
										)}
									</Popup>
								);
							} else {
								return (
									<Lesson key={i}>
										<EVideo width="24" height="24" />{' '}
										<span dangerouslySetInnerHTML={{ __html: lsn.title }} />
										<Code>{lsn.length}</Code>
									</Lesson>
								);
							}
						})}
					</Info>
				</Module>
			))}
		</Wrap>
	</>
);

const Info = styled.div``;
const Lesson = styled.p`
	font-family: ${(props) => props.theme.f2};

	iframe {
		max-width: 100%;
	}
	
	${rmq('t')} {
		font-size: 1.6rem;
	}

	${rmq('ml')} {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 37.5rem;

		span strong,
		span > span {
			display: none;
		}
	}

	${rmq('mm')} {
		max-width: 32.5rem;
	}
	${rmq('ms')} {
		max-width: 30rem;
	}
	${rmq('315')} {
		white-space: normal;
	}
`;

const Modal = styled.div`
	position: relative;
	padding: ${(props) => props.theme.vr * 0.4}rem;
	background: ${(props) => props.theme.c};

	&::before,
	&::after {
		content: '';
		background: ${(props) => props.theme.c};
		position: absolute;
		width: 90%;
		height: 90%;
		transform: rotateZ(5deg);
		z-index: -1;
		left: 0.5rem;
		top: -1rem;

		${rmq('820')} {
			width: 85%;
		}
		${rmq('t')} {
			width: 80%;
		}
		${rmq('700')} {
			width: 60%;
			left: 1rem;
			top: -1.5rem;
			transform: rotateZ(2deg);
		}
		${rmq('275')} {
			display: none;
		}
	}

	&::after {
		transform: rotateZ(15deg);
		left: 3rem;
		top: 0.1rem;

		${rmq('900')} {
			left: 8rem;
			top: -1.5rem;
			transform: rotateZ(6deg);
		}
		${rmq('ms')} {
			left: 6rem;
		}
		${rmq('275')} {
			display: none;
		}
	}
`;
const Close = styled.button`
	cursor: pointer;
	position: absolute;
	display: block;
	padding: 0;
	border: none;
	font-size: ${(props) => props.theme.vr * 1.3}rem;
	line-height: ${(props) => props.theme.vr * 1.3}rem;
	width: ${(props) => props.theme.vr * 1.3}rem;
	height: ${(props) => props.theme.vr * 1.3}rem;
	border-radius: 50%;
	background: ${(props) => props.theme.c2};
	color: ${(props) => props.theme.w};
	right: -${(props) => props.theme.vr * 0.9}rem;
	top: -${(props) => props.theme.vr * 0.9}rem;

	${rmq('ml')} {
		right: ${(props) => props.theme.vr * 0.2}rem;
		top: ${(props) => props.theme.vr * 0.2}rem;
		background: ${(props) => props.theme.c};
		color: ${(props) => props.theme.black1};
		font-size: ${(props) => props.theme.vr * 2}rem;
		line-height: ${(props) => props.theme.vr * 2}rem;
		width: ${(props) => props.theme.vr * 2}rem;
		height: ${(props) => props.theme.vr * 2}rem;
	}
`;

const Play = styled.span`
	cursor: pointer;
	background: ${(props) => props.theme.c};
	color: ${(props) => props.theme.black};
	padding: 0.2rem 0.5rem;
	margin: 0 1rem;
	font-size: 65%;

	${rmq('ml')} {
		font-size: 75%;
	}
`;
